import { Box, Typography, IconButton } from "@mui/material";
import { alpha } from "@mui/material/styles";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";

// `children`: lo que va entre «Atrás» y el encabezado (en tu propio perfil, el aviso «Así te ven los demás»)
const ProfileHeader = ({ user, children }) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <IconButton
          onClick={() => navigate(-1)}
          sx={{
            // Tonos claros del azul medio del tema (antes #E8EFFF y #D0DFFF a mano)
            bgcolor: (t) => alpha(t.palette.secondary.main, 0.16),
            mr: 1,
            '&:hover': { bgcolor: (t) => alpha(t.palette.secondary.main, 0.32) },
            width: 32,
            height: 32,
            borderRadius: '8px'
          }}
          size="small"
        >
          <ArrowBackIosNewIcon sx={{ fontSize: 14, color: 'primary.main' }} />
        </IconButton>
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'primary.main' }}>
          Atrás
        </Typography>
      </Box>

      {children}

      <Box className="profile-header-banner">
        <Box className="banner-content">
          <Typography variant="h3" component="h1" sx={{ color: 'primary.main', fontWeight: 700, mb: 1 }}>
            Perfil <br /> del proveedor
          </Typography>
          <Typography variant="body1" color="primary">
            Conoce el perfil de {user?.name || 'el proveedor'}, su experiencia y los servicios que ofrece
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileHeader;
